module.exports = new __parcel__URL__("new-roadmap.76d9897f.svg").toString();